import axios from "axios";
import { request } from "@/utils/request";

/**
 * 查询账号
 * @param {*} data
 * @returns
 */
export function selectAdmin(data) {
  return request({
    url: `/administratorSub/selectAuthGroup`,
    method: "POST",
    data,
  });
}

/**
 * 查询角色
 * @param {*} data
 * @returns
 */
export function selectAuthGroup(data) {
  return request({
    url: `/administratorSub/selectAuthGroupList`,
    method: "POST",
    data,
  });
}

/**
 * 查询角色
 * @param {*} data
 * @returns
 */
export function selectAdminById(data) {
  return request({
    url: `/administratorSub/selectAdminById`,
    method: "POST",
    data,
  });
}



/**
 * 新增
 * @param {*} data
 * @returns
 */
export function addAdmin(data) {
  return request({
    url: `/administrator/addAuthGroup`,
    method: "POST",
    data,
  });
}

/**
 * 更改
 * @param {*} data
 * @returns
 */
export function updateAdmin(data) {
  return request({
    url: `/administrator/updateAuthGroup`,
    method: "POST",
    data,
  });
}


/**
 * 删除
 * @param {*} data
 * @returns
 */
export function deleteAdmin(data) {
  return request({
    url: `/administrator/deleteAuthGroup`,
    method: "POST",
    data,
  });
}
